import React from 'react';
import PropTypes, { any } from 'prop-types';

import { required } from '../../../../utils/form-validation';
import { removeNonPrintableCharacters } from '../../../../utils/misc';
import {
    Input,
} from '../../../Form';

import { maxTitleLength } from '../../../../utils/eventConstants';
import { useStatsig } from '../../../hooks/useStatsig';

const EventName = (props) => {
    const {
        field,
        formApi,
        clubTierType,
    } = props;

    const { values, errors, asyncErrors, submitting } = formApi;
    const { checkGate, featureGates } = useStatsig();
    const isEventCharacterCountEnabled = checkGate(featureGates.WEB_EVENT_CHARACTER_COUNT);

    let eventNamePlaceHolder = 'Ex: SoCal Summer Challenge';
    if (values.eventType === 9) { // non-tennis
        if (clubTierType.isCollege) {
            eventNamePlaceHolder = 'Ex. Fan Match Day Experience';
        } else if (clubTierType.isHighSchool) {
            eventNamePlaceHolder = 'Ex.Team Meeting';
        } else {
            eventNamePlaceHolder = 'Ex. Member Social';
        }
    }

    const fieldValue = Array.isArray(field)
        ? field.reduce((obj, key) => obj?.[key], values)
        : values[field];
    const charCount = (fieldValue || '').length;

    return (
        <div className="col-12">
            <Input
                label="What's your event called?"
                id="name"
                field={field}
                type="text"
                placeholder={eventNamePlaceHolder}
                validate={required}
                errors={errors}
                asyncErrors={asyncErrors}
                submitting={submitting}
                maxLength={isEventCharacterCountEnabled ? maxTitleLength : null}
                hoverText={(
                    <>
                        <strong className="fs16">Event Title Guidelines</strong>
                        <p className="mt8">Please follow these guidelines when creating your event titles.</p>
                        <ul>
                            <li>Event titles must be 75 characters or less (including spaces and punctuation).</li>
                        </ul>
                    </>
                )}
                onChange={(e) => {
                    formApi.setValue(field, removeNonPrintableCharacters(e));
                }}
            />
            {isEventCharacterCountEnabled && (
                <div className="text-right small text-dark mt-12">
                    {`Characters: ${charCount}/`}<span className="text-dark text-bold">{maxTitleLength}</span>
                </div>
            )}
        </div>
    );
};

EventName.propTypes = {
    field: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
    clubTierType: PropTypes.objectOf(any).isRequired,
};

export default EventName;
